export default "__VITE_ASSET__60f3ed02__"